export default __webpack_public_path__ + "static/media/home-photography-img-06.2400ce65.jpg";